import React, { useState } from 'react'
import { message, Spin } from 'antd'
import history from '@utils/history'
import LoginForm from './components/LoginForm'

import styles from '@less/login/index.less'
import btgWeb from '@images/login/login_bg.webp'
import bgWeb from '@images/login/leftIcon.webp'
import btgPng from '@images/login/login_bg.png'
import bgPng from '@images/login/leftIcon.png'
import bottomBg from '@images/login/bottom.png'

const isSupportWebp =
  !![].map &&
  document
    .createElement('canvas')
    .toDataURL('image/webp')
    .indexOf('data:image/webp') === 0

const btg = isSupportWebp ? btgWeb : btgPng
const bg = isSupportWebp ? bgWeb : bgPng
const style = {
  login: {
    background: `url(${btg}) no-repeat scroll top`,
    backgroundSize: '100% auto'
  },
  background: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '300px',
    background: `url(${bottomBg}) no-repeat scroll bottom`,
    backgroundSize: '100% 100%',
    zIndex: 100
  },
  form: {
    background: `url(${bg}) no-repeat scroll left`,
    backgroundSize: '554px auto',
    zIndex: 99
  }
}

message.config({
  top: 100,
  duration: 2,
  maxCount: 3
})

function Login() {
  const [loading, setLoading] = useState(false)
  return (
    <Spin spinning={loading} className={styles.spin}>
      <div className={styles.login} style={style.login}>
        <div style={style.background}></div>
        <div className={styles.content} style={style.form}></div>
        <div className={styles.content} style={{ zIndex: 101 }}>
          <div className={styles.wrapper}>
            <div className={styles.loginFrom}>
              <LoginForm setLoading={setLoading} />
              <div className={styles.forgot}>
                <a onClick={_ => history.push('/forget-password')}>忘记密码</a>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          Copyright©2017～2021 埃森哲企云版权所有 浙ICP备17036994号-2 浙公网安备
          33010802008555号
        </div>
      </div>
    </Spin>
  )
}

export default Login
